import { render, staticRenderFns } from "./Osgaijia.vue?vue&type=template&id=281f4011"
import script from "./Osgaijia.vue?vue&type=script&lang=js"
export * from "./Osgaijia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports